import { render, staticRenderFns } from "./Punchout.vue?vue&type=template&id=83a148ca&scoped=true&"
import script from "./Punchout.vue?vue&type=script&lang=js&"
export * from "./Punchout.vue?vue&type=script&lang=js&"
import style0 from "./Punchout.vue?vue&type=style&index=0&id=83a148ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a148ca",
  null
  
)

export default component.exports